import { i18n } from "@lingui/core";
import React from "react";
import type { RecommerceAd } from "../types";
import type { AdImageProps } from "./AdImage";
import { AdImage } from "./AdImage";

type AdImageWrapperProps = {
	ad: RecommerceAd;
	image?: (props: AdImageProps) => React.ReactElement | null;
	imageClass: string;
	sizes?: string;
};

export function AdImageWrapper(props: AdImageWrapperProps) {
	const { ad, image, imageClass, sizes } = props;

	const adaptiveAspect = true;
	const aspectClass = "";

	const imageProps = {
		adaptiveAspect,
		alt: i18n.t({
			id: "search.ad.recommerce.image-alt",
			message: "Ad image",
		}),
		aspectClass,
		crop: true,
		imageClass,
		sizes,
	};

	return image ? image(imageProps) : <AdImage {...imageProps} {...ad.image} />;
}
